import { CarsLink, CarTag, CatalogListLink } from '../types/brandSchema';

export const Cars: CarsLink[] = [
  {
    title: 'R14',
    tags: [
      { title: '175/65 R14', href: '/catalog/tyres/all_sizes/175-65-14/' },
      { title: '175/70 R14', href: '/catalog/tyres/all_sizes/175-70-14/' },
      { title: '185/60 R14', href: '/catalog/tyres/all_sizes/185-60-14/' },
      { title: '185/65 R14', href: '/catalog/tyres/all_sizes/185-65-14/' },
      { title: '185/70 R14', href: '/catalog/tyres/all_sizes/185-70-14/' },
    ],
  },
  {
    title: 'R15',
    tags: [
      { title: '185/60 R15', href: '/catalog/tyres/all_sizes/185-60-15/' },
      { title: '185/65 R15', href: '/catalog/tyres/all_sizes/185-65-15/' },
      { title: '195/55 R15', href: '/catalog/tyres/all_sizes/195-55-15/' },
      { title: '195/60 R15', href: '/catalog/tyres/all_sizes/195-60-15/' },
      { title: '195/65 R15', href: '/catalog/tyres/all_sizes/195-65-15/' },
      { title: '205/65 R15', href: '/catalog/tyres/all_sizes/205-65-15/' },
    ],
  },
  {
    title: 'R16',
    tags: [
      { title: '195/55 R16', href: '/catalog/tyres/all_sizes/195-55-16/' },
      { title: '205/55 R16', href: '/catalog/tyres/all_sizes/205-55-16/' },
      { title: '205/60 R16', href: '/catalog/tyres/all_sizes/205-60-16/' },
      { title: '205/65 R16', href: '/catalog/tyres/all_sizes/205-65-16/' },
      { title: '215/60 R16', href: '/catalog/tyres/all_sizes/215-60-16/' },
    ],
  },
  {
    title: 'R17',
    tags: [
      { title: '215/50 R17', href: '/catalog/tyres/all_sizes/215-50-17/' },
      { title: '215/55 R17', href: '/catalog/tyres/all_sizes/215-55-17/' },
      { title: '225/45 R17', href: '/catalog/tyres/all_sizes/225-45-17/' },
      { title: '225/50 R17', href: '/catalog/tyres/all_sizes/225-50-17/' },
      { title: '225/55 R17', href: '/catalog/tyres/all_sizes/225-55-17/' },
    ],
  },
  {
    title: 'R18',
    tags: [
      { title: '225/45 R18', href: '/catalog/tyres/all_sizes/225-45-18/' },
      { title: '235/45 R18', href: '/catalog/tyres/all_sizes/235-45-18/' },
      { title: '245/45 R18', href: '/catalog/tyres/all_sizes/245-45-18/' },
    ],
  },
];

export const offRoads: CarsLink[] = [
  {
    title: 'R16',
    tags: [
      { title: '185/75 R16', href: '/catalog/tyres/all_sizes/185-75-16/' },
      { title: '215/55 R16', href: '/catalog/tyres/all_sizes/215-55-16/' },
      { title: '215/65 R16', href: '/catalog/tyres/all_sizes/215-65-16/' },
      { title: '215/70 R16', href: '/catalog/tyres/all_sizes/215-70-16/' },
      { title: '225/75 R16', href: '/catalog/tyres/all_sizes/225-75-16/' },
    ],
  },
  {
    title: 'R17',
    tags: [
      { title: '215/60 R17', href: '/catalog/tyres/all_sizes/215-60-17/' },
      { title: '215/65 R17', href: '/catalog/tyres/all_sizes/215-65-17/' },
      { title: '225/60 R17', href: '/catalog/tyres/all_sizes/225-60-17/' },
      { title: '225/65 R17', href: '/catalog/tyres/all_sizes/225-65-17/' },
      { title: '235/55 R17', href: '/catalog/tyres/all_sizes/235-55-17/' },
      { title: '235/65 R17', href: '/catalog/tyres/all_sizes/235-65-17/' },
      { title: '265/65 R17', href: '/catalog/tyres/all_sizes/265-65-17/' },
    ],
  },
  {
    title: 'R18',
    tags: [
      { title: '215/55 R18', href: '/catalog/tyres/all_sizes/215-55-18/' },
      { title: '225/55 R18', href: '/catalog/tyres/all_sizes/225-55-18/' },
      { title: '225/60 R18', href: '/catalog/tyres/all_sizes/215-60-18/' },
      { title: '235/55 R18', href: '/catalog/tyres/all_sizes/235-55-18/' },
      { title: '235/60 R18', href: '/catalog/tyres/all_sizes/235-60-18/' },
      { title: '255/55 R18', href: '/catalog/tyres/all_sizes/255-55-18/' },
      { title: '265/60 R18', href: '/catalog/tyres/all_sizes/265-60-18/' },
    ],
  },
];

export const CatalogList: CatalogListLink[] = [
  {
    title: 'Летние шины',
    image: '/next/img/home/catalog/SummerTires.png',
    href: '/catalog/tyres/leto/',
    testid: 'catalog-tyres-leto',
  },
  {
    title: 'Зимние шины',
    image: '/next/img/home/catalog/WinterTires.png',
    href: '/catalog/tyres/zima/',
    testid: 'catalog-tyres-zima',
  },
  {
    title: 'Бесплатный шиномонтаж',
    image: '/next/img/catalog/free.png',
    href: '/catalog/tyres-bshm/',
    testid: 'catalog-tyres-bshm',
  },
  {
    title: 'Грузовые шины',
    image: '/next/img/catalog/truckTyres.png',
    href: '/catalog/trucktyres/',
    testid: 'catalog-trucktyres',
  },
  {
    title: 'Внедорожные шины',
    image: '/next/img/catalog/suvTyres.png',
    href: '/catalog/tyres/off-road-tyres/',
    testid: 'catalog-tyres-off-road-tyres',
  },
  {
    title: 'Коммерческие шины',
    image: '/next/img/home/catalog/CommercialTires.png',
    href: '/catalog/tyres/commercial/',
    testid: 'catalog-tyres-commercial',
  },
];

export const cats: CarTag[] = [
  {
    title: 'Шины XL',
    href: '/catalog/tyres/xl/',
  },
  {
    title: 'Внедорожные шины',
    href: '/catalog/tyres/off-road-tyres/',
  },
  {
    title: 'Шины шипованные',
    href: '/catalog/tyres/thorn/',
  },
  {
    title: 'Шины Runflat',
    href: '/catalog/tyres/runflat/',
  },
  {
    title: 'Шины фрикционные',
    href: '/catalog/tyres/friction-tyres/',
  },
  {
    title: 'Низкопрофильная резина',
    href: '/catalog/tyres/low-profile/',
  },
  {
    title: 'Всесезонные шины',
    href: '/catalog/tyres/all-season/',
  },
  {
    title: '175/70 R13',
    href: '/catalog/tyres/all_sizes/175-70-13/',
  },
  {
    title: '245/45 R19',
    href: '/catalog/tyres/all_sizes/245-45-19/',
  },
  {
    title: 'Все размеры шин',
    href: '/catalog/tyres/all_sizes/',
  },
];

export const acts: CarTag[] = [
  {
    title: 'Недорогие шины',
    href: '/actions/',
  },
  {
    title: 'Шины со скидкой',
    href: '/actions/',
  },
  {
    title: 'Шины с БШМ',
    href: '/actions/',
  },
];

export const brands: CarTag[] = [
  {
    title: 'Российские шины',
    href: '/catalog/tyres/russian-tyres/',
  },
  {
    title: 'Китайские шины',
    href: '/catalog/tyres/china-tyres/',
  },
  {
    title: 'Европейские шины',
    href: '/catalog/tyres/europian-tyres/',
  },
  {
    title: 'Корейские шины',
    href: '/catalog/tyres/korean-tyres/',
  },
  {
    title: 'Японские шины',
    href: '/catalog/tyres/japan-tyres/',
  },
  {
    title: 'Американские шины',
    href: '/catalog/tyres/usa-tyres/',
  },
];

export const summer: CarTag[] = [
  {
    title: 'R13',
    href: '/catalog/tyres/leto/r13/',
  },
  {
    title: 'R14',
    href: '/catalog/tyres/leto/r14/',
  },
  {
    title: 'R15',
    href: '/catalog/tyres/leto/r15/',
  },
  {
    title: 'R16',
    href: '/catalog/tyres/leto/r16/',
  },
  {
    title: 'R17',
    href: '/catalog/tyres/leto/r17/',
  },
  {
    title: 'R18',
    href: '/catalog/tyres/leto/r18/',
  },
  {
    title: 'R19',
    href: '/catalog/tyres/leto/r19/',
  },
  {
    title: 'R20',
    href: '/catalog/tyres/leto/r20/',
  },
];

export const winter: CarTag[] = [
  {
    title: 'R13',
    href: '/catalog/tyres/zima/r13/',
  },
  {
    title: 'R14',
    href: '/catalog/tyres/zima/r14/',
  },
  {
    title: 'R15',
    href: '/catalog/tyres/zima/r15/',
  },
  {
    title: 'R16',
    href: '/catalog/tyres/zima/r16/',
  },
  {
    title: 'R17',
    href: '/catalog/tyres/zima/r17/',
  },
  {
    title: 'R18',
    href: '/catalog/tyres/zima/r18/',
  },
  {
    title: 'R19',
    href: '/catalog/tyres/zima/r19/',
  },
  {
    title: 'R20',
    href: '/catalog/tyres/zima/r20/',
  },
];
